
export const keys = {
    all: ["notification-messages"],
    lists: () => [
        ...keys.all,
        "list"
    ],
    list: (
        groupID: number,
    ) => [
        ...keys.lists(),
        {
            groupID,
        }
    ]
};
